/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { useModal } from '@jutro/components';
import {
    AdaptiveDataView,
    DataViewColumns,
    DataViewOverlay,
    GenericColumn,
} from '@jutro/legacy/dataview';
import { useTranslator } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { uwIssuesMessages } from 'gw-components-platform-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import gatewayMessages from '../../gateway.messages';
import messages from './UnderwritingComponent.messages';
import metadata from './UnderwritingComponent.metadata.json5';
import styles from './UnderwritingComponent.module.scss';
import UWUtil from './UWUtil';

const UWIssuesTableComponent = props => {
    const { uwIssues, noRecordsMessage, uwUtil } = props;
    const translator = useTranslator();

    const getBlockingPointDisplayKey = useCallback(
        blockingPoint => {
            switch (blockingPoint) {
                case 'BlocksBind':
                    return translator(uwIssuesMessages.blocksBind);
                case 'BlocksQuote':
                    return translator(uwIssuesMessages.blocksQuote);
                case 'BlocksQuoteRelease':
                    return translator(uwIssuesMessages.blocksQuoteRelease);
                case 'NonBlocking':
                    return translator(uwIssuesMessages.nonBlocking);
                default:
                    return blockingPoint;
            }
        },
        [translator]
    );

    const getUWIssueStatusByOffering = useCallback(
        (uwIssue, index, id) => {
            const offering = id !== 'Status' ? id : undefined;

            // US26432
            const currentUWIssue = offering
                ? _.find(uwIssue.row.onOfferings, offer => offer.offering === offering)
                : uwIssue.row;

            let displayStatus = translator(messages.notApplicable);

            if (!currentUWIssue) {
                return displayStatus;
            }

            if (currentUWIssue.currentBlockingPoint) {
                displayStatus = currentUWIssue.currentBlockingPoint === 'BlocksOfferSubmission_Ext'
                    ? 'Blocks Offer Submission' :
                    getBlockingPointDisplayKey(currentUWIssue.currentBlockingPoint === "Rejected" ?
                        'Declined' : currentUWIssue.currentBlockingPoint); // DE16945, DE17053
            }

            return currentUWIssue.currentBlockingPoint === 'NonBlocking' &&
                currentUWIssue.hasApprovalOrRejection
                ? translator(messages.approved)
                : displayStatus;
        },
        [getBlockingPointDisplayKey, translator]
    );

    const getCell = useCallback(
        (items, index) => {
            const isIgnoreId = ['shortDescription', 'longDescription'].includes(
                items.columnProps.id
            );

            if (!isIgnoreId) {
                return getUWIssueStatusByOffering(items, index, items.columnProps.id);
            }

            return items.columnProps.id === 'shortDescription' ? items.row.shortDescription :
                items.row.longDescription // DE16945
        },
        [getUWIssueStatusByOffering]
    );
    const getHeader = useCallback(id => {
        const headerInfo = {
            shortDescription: messages.shortDescription,
            longDescription: messages.longDescription,
            Status: messages.jobStatusUW,
        };

        return headerInfo[id] || id;
    }, []);

    const getTableColumns = useCallback(() => {
        const offeringAndStatus = uwUtil.offerings || ['Status'];
        const bothOfferings = [
            'shortDescription',
            'longDescription',
            'Status', // US26432
        ];
        const flattenOfferings = _.uniq(_.flatten(bothOfferings));
        const dynamicColumn = flattenOfferings.map(issueOffer => (
            <GenericColumn
                id={issueOffer}
                textAlign="left"
                header={getHeader(issueOffer)}
                renderCell={getCell} // US26432
            />
        ));

        return dynamicColumn;
    }, [getCell, getHeader, uwUtil.offerings]);

    // DE16973 UW Issues should not be displayed on Quote summary screen for non-blocking quotes
    // DE17007 Approved UW Issues should display with short and long description along with status.
    return (
        <AdaptiveDataView
            className={styles.noRowMessageStyle}
            data={_.filter(uwIssues, (uw) => uw.currentBlockingPoint !== 'NonBlocking' ||
                (uw.currentBlockingPoint === 'NonBlocking' && uw.hasApprovalOrRejection))}
        >
            <DataViewOverlay
                noRowsMessage={translator(
                    messages[`noOpenUnderwriting${uwUtil.jobType}`]
                )}
            />
            <DataViewColumns>{getTableColumns()}</DataViewColumns>
        </AdaptiveDataView>
    );
};

UWIssuesTableComponent.propTypes = {
    uwIssues: PropTypes.shape([]).isRequired,
    noRecordsMessage: PropTypes.string.isRequired,
    uwUtil: PropTypes.shape({
        offerings: PropTypes.shape([]),
    }).isRequired,
};

const UnderwritingComponent = props => {
    const { showAlert } = useModal();

    const {
        job,
        continueJob,
        onWithdrawJob,
        onEditJob,
        jobService,
        authUserData,
        authHeader,
        onUpdateJobSummary,
        isQuoteScreen
    } = props;
    const translator = useTranslator();
    const [formData, updateFormData] = useState({});
    const [showReferToUW, setShowReferToUW] = useState(false);
    const isAgent = authUserData?.userType === 'producer' || false;
    const isTFPA = authUserData?.associationName_TWIA === 'tfpa';

    const uwutil = useMemo(() => UWUtil(job, isAgent), []);

    const getCell = useCallback((items, index, property) => items[property.id], []);

    // DE17683
    const showUWIssuesAlert = useCallback(
        () => {
            // if (uwutil.jobType === 'Renewal') {
                return uwutil.hasUwIssuesExcludingNonBlocking && ['Draft', 'Quoted'].includes(job.statusCode);
            // }

            // return uwutil.hasUwIssues &&
            //     !['Bound', 'Withdrawn'].includes(job.statusCode)
        }, [job, uwutil]
    );

    const showMessageBox = () => job
        ? !job.isEditLocked &&
        showReferToUW &&
        job.statusCode !== 'Withdrawn' &&
        uwutil.uwIssuesAreBlocking
        : false;


    const showUWIssuesTriggeredMsg = () => {
        if (uwutil.jobType === 'Renewal') {
            return false;
        }
        // if (isTFPA && uwutil.jobType === 'PolicyChange') {
        //     return showUWIssuesAlert() && !job.isEditLocked && uwutil.uwIssuesAreBlocking
        //     && uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA && ['Draft', 'Quoted'].includes(job.statusCode); // DE18273
        // }
        // DE18104,DE18106,DE18154,DE18155,DE18156,DE18157,DE18283
        return isTFPA ? showUWIssuesAlert() && !checkPolicyHold()
        && ((uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA && !job.isEditLocked) || uwutil.hasBlockingUWIssuesAndAnyRejected_TWIA) && 
        ['Draft', 'Quoted'].includes(job.statusCode) : showUWIssuesAlert() && !job.isEditLocked && uwutil.uwIssuesAreBlocking
            && !uwutil.uwIssuesHaveBeenInspectedByUW && ['Draft', 'Quoted'].includes(job.statusCode);
        
    }

    const showReferredToUWMsg = useCallback(
        () => {
            if (uwutil.jobType === 'Renewal' ) {
                return uwutil.isLockedToUser
                    || (!_.isNil(job)
                        && ['Draft', 'Quoted'].includes(job.statusCode)
                        && !uwutil.isLockedToUser
                        && uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA);
            }
            if (uwutil.jobType === 'PolicyChange' && isTFPA) { // DE18333
                return (!_.isNil(job)
                        && ['Draft', 'Quoted', 'Submitted_Ext'].includes(job.statusCode)
                        && uwutil.isLockedToUser
                        && (uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA
                            || uwutil.hasBlockingUWIssuesAndAnyRejected_TWIA || uwutil.hadBlockingUWIssuesAndAllApproved));
            }
            // DE18104,DE18106,DE18154,DE18155,DE18156,DE18157
            if (uwutil.jobType === 'Submission' && isTFPA) {
                return (!_.isNil(job)
                        && ['Draft', 'Quoted', 'Submitted_Ext'].includes(job.statusCode)
                        && uwutil.isLockedToUser
                        && (uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA || uwutil.hasBlockingUWIssuesAndAnyRejected_TWIA));
            }
            // DE17897,DE18035,DE18883-reverted the logic for this defect
            return showUWIssuesAlert() && job.isEditLocked && uwutil.hasUwIssues // && job.createdByMe
        },
        [job, showUWIssuesAlert, uwutil, isTFPA]
    );

    const showUWIssuesRejectedMsg = useCallback(
        () => {
            if (uwutil.jobType === 'Renewal' || uwutil.jobType === 'PolicyChange' 
                || (uwutil.jobType === 'Submission' && isTFPA)) {
                return showUWIssuesAlert()
                    && !uwutil.isLockedToUser
                    && !uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA
                    && uwutil.hasBlockingUWIssuesAndAnyRejected_TWIA;
            }

            return showUWIssuesAlert() && !job.isEditLocked && uwutil.uwIssuesHaveBeenInspectedByUW;
        },
        [isTFPA, job, showUWIssuesAlert, uwutil]
    );

    const showUWIssuesApprovedMsg = useCallback(
        () => {
            if (isTFPA && (uwutil.jobType === 'Submission')) { // DE17974
                return !_.isNil(job)
                    && ['Draft', 'Quoted'].includes(job.statusCode)
                    && uwutil.hadBlockingUWIssuesAndAllApproved;
            }
            if (uwutil.jobType === 'Renewal' || uwutil.jobType === 'PolicyChange') {
                return !_.isNil(job)
                    && ['Draft', 'Quoted'].includes(job.statusCode)
                    && !uwutil.isLockedToUser
                    && uwutil.hadBlockingUWIssuesAndAllApproved;
            }
            // DE17837
            return (uwutil.hasNonBlockingUWIssuesButApproved 
                && ['Draft', 'Quoted'].includes(job.statusCode)) && (!job.isEditLocked || isTFPA);
        },
        [job, uwutil, isTFPA]
    );


    const theJobStateForLock = useCallback(() => ['Withdrawn'].includes(job.statusCode), [job]);

    const getNotificationContent = useCallback(() => ({
        infoMessageTitle: translator(
            messages[`approvedForThis${uwutil.jobType}`]
        ),
        infoMessageDescription: continueJob.isContinueTransaction
            ? translator(messages[`withdrawOrContinue${uwutil.jobType}`])
            : translator(messages[`withdrawThe${uwutil.jobType}`]),
        withDrawContent: translator(messages[`withdraw${uwutil.jobType}`]),
        continueContent: translator(messages[`continue${uwutil.jobType}`]),
    }), [continueJob.isContinueTransaction, translator, uwutil.jobType]);

    const getNotificationContentRenewal = useCallback(() => ({
        infoMessageTitle: translator(
            messages[`approvedForThis${uwutil.jobType}`]
        ),
    }), [translator, uwutil.jobType]);

    const getWithDrawInfo = useCallback(
        isWithDraw => {
            const { link, message } = uwutil.translateWithdrawn;

            return isWithDraw ? translator(link) : translator(message);
        },
        [translator, uwutil.translateWithdrawn]
    );

    const getWithDrawInfo_twia = useCallback(
        () => {
            const { link, message } = uwutil.translateWithdrawn;

            return translator(link);
        },
        [translator, uwutil.translateWithdrawn]
    );
    
    const getWithDrawInfo_tfpa = () => {
        return translator(messages.tfpaWithdrawMessage);
    }

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);

            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    const referQuoteToUnderWriter = useCallback(() => {
        const { uwNoteForUnderwriter } = formData;
        const noteForUW =
            uwNoteForUnderwriter === '' ? null : uwNoteForUnderwriter;

        jobService
            .referToUnderwriter(job.jobNumber, noteForUW, authHeader)
            .then(
                jobResponse => {
                    setShowReferToUW(false);
                    onUpdateJobSummary(jobResponse);
                },
                () => {
                    showAlert({
                        title: gatewayMessages.modalError,
                        message: messages.errorSendingJobForReview,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                }
            );
    }, [authHeader, formData, job.jobNumber, jobService, onUpdateJobSummary, showAlert]);

    const isRejectToUnderwriterVisible = useCallback(() => uwutil.uwIssuesHaveBeenInspectedByUW && uwutil.uwIssuesAreBlocking, [uwutil])

    const checkPolicyHold = useCallback(() => uwutil.uwIssues.some(
        issue =>
            issue.isPolicyHoldTWIA
    ), [uwutil])

    const onCancelReferUW = useCallback(() => {
        setShowReferToUW(false);
    }, []);

    const onReferToUW = useCallback(() => {
        setShowReferToUW(true);
    }, []);

    const showQuoteSummaryInfoBox = useCallback(() => ['Submitted_Ext', 'Declined', 'Issued', 'Withdrawn', 'NotTaken', 'Expired'].includes(job.statusCode) ||
        ((job.uwlocked && !isTFPA ) && ['Draft', 'Quoted'].includes(job.statusCode)), [isTFPA, job])

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell,
            handleEditJob: onEditJob,
            handleUnderwrite: referQuoteToUnderWriter,
            handleWithDraw: onWithdrawJob,
            onCancelReferUW,
            onReferToUW,
            writeValue,
        },
        resolveComponentMap: {
            uwissuestablecomponent: UWIssuesTableComponent,
        },
    };

    const isWithDrawVisible = () => {
        if (job.jobType === 'Renewal' || uwutil.jobType === 'Renewal') {
            return false
        }
        if (uwutil.jobType === 'Submission' && isTFPA) {
            return !(!_.isNil(job)
                    && ['Submitted_Ext'].includes(job.statusCode)
                    // && uwutil.isLockedToUser
                    && (uwutil.hasBlockingUWIssuesAndAnyOpen_TWIA || uwutil.hasBlockingUWIssuesAndAnyRejected_TWIA));
        }

        return true
    }

    const overrideProps = {
        underwritingIssues: {
            uwIssues: job.underwritingIssues,
            uwUtil: uwutil,
            noRecordsMessage: translator(
                messages[`noOpenUnderwriting${uwutil.jobType}`]
            ),
        },
        uwIssuesWarningNotification: {
            job,
        },
        quoteNotificationIsApproved: {
            notificationContent: uwutil.jobType !== 'Renewal' ?
                showUWIssuesApprovedMsg() && getNotificationContent() :
                showUWIssuesApprovedMsg() && getNotificationContentRenewal(),
            transactionVisibleActions: uwutil.jobType !== 'Renewal' ? continueJob : "",
            visible: showQuoteSummaryInfoBox() ? false : showUWIssuesApprovedMsg(),
        },
        uwIssuesRaisedContainer: {
            visible:showUWIssuesTriggeredMsg(),
        },
        referForReviewContainer: {
            visible:
                showReferredToUWMsg() &&
                !showUWIssuesRejectedMsg() &&
                !showUWIssuesApprovedMsg(),
        },
        uwIssuesRejectedByUnderViewerContainer: {
            visible: isTFPA ? false : showUWIssuesRejectedMsg() && !showUWIssuesApprovedMsg(),
        },
        uwIssuesLockedContainer: {
            visible: isTFPA ? false :
                uwutil.isLockedToUser &&
                !showReferredToUWMsg() &&
                !theJobStateForLock(),
        },
        referToUWPanel: {
            visible: showMessageBox(),
        },
        showIssuesHeader: {
            content: translator(messages[`underwriter${uwutil.jobType}`]),
        },
        underWritingIssueLine1: {
            content: translator(
                messages[`toCompletePointersFor${uwutil.jobType}`]
            ),
        },
        editJobForAccept: {
            content: (isTFPA && uwutil.jobType === 'PolicyChange') ? translator(messages[`tfpaEdit${uwutil.jobType}`]) : translator(messages[`edit${uwutil.jobType}`]),
        },
        reviewForUnderWritter: {
            content: (isTFPA && uwutil.jobType === 'PolicyChange') ? translator(messages[`tfpaReview${uwutil.jobType}`]) : translator(messages[`review${uwutil.jobType}`])
        },
        referReviewForUW: {
            content: (isTFPA && uwutil.jobType === 'PolicyChange') ? translator(messages[`tfpaUnderwriterReviewing${uwutil.jobType}`]) : translator(
                messages[`underwriterReviewing${uwutil.jobType}`]
            ),
        },
        referredToUnderwriterMessage: {
            content: translator(uwutil.getReferredToUnderwriterMessage),
        },
        rejectedIssuesHeader: {
            title: !uwutil.offerings
                ? translator(messages.rejectedByUW)
                : translator(messages[`offerUnresolvedIssueFor${uwutil.jobType}`]),
        },
        editOrReferUW: {
            content: translator(messages[`editOrRefer${uwutil.jobType}`]),
            visible: uwutil.jobType !== 'Renewal'
        },
        // rejectWarningActionsInfo: {
        //     visible: isNotRenewal
        // },
        withdrawLink: {
            content: (isTFPA && uwutil.jobType === 'PolicyChange') ? getWithDrawInfo_tfpa() : getWithDrawInfo_twia(), // US26432
        },
        wishToContinue: {
            //  content: getWithDrawInfo_twia(),
        },
        referReviewWithDrawJob: {
            content: translator(messages[`withdraw${uwutil.jobType}`]),
            visible: isWithDrawVisible()
        },
        rejectReviewWithDrawJob: {
            content: translator(messages[`withdraw${uwutil.jobType}`]),
            visible: uwutil.jobType !== 'Renewal'
        },
        rejectEditJob: {
            content: translator(messages[`warningEdit${uwutil.jobType}`]),
            visible: uwutil.jobType !== 'Renewal'
        },
        raisedEditJob: {
            content: translator(messages[`warningEdit${uwutil.jobType}`]),
        },
        lockedIssuesHeader: {
            content: translator(messages[`locked${uwutil.jobType}`]),
        },
        referralInfo: {
            content: translator(messages[`referralInfo${uwutil.jobType}`]),
        },
        wantToReferInfo: {
            content: translator(messages[`referToUW${uwutil.jobType}`]),
        },
        // US26432
        rejectReferToUnderwriterButton: {
            visible: !isRejectToUnderwriterVisible()
        },
        proceedOffering: {
            visible: !isRejectToUnderwriterVisible()
        },
        underwritingTableContainer: {
            visible: !isQuoteScreen
        },
        reviewForUnderWritterList: {
            visible: !checkPolicyHold()
        },
        referToUnderwriterButton: {
            visible: !checkPolicyHold()
        },
        uwPolicyHoldTwia: {
            content: translator(messages.uwPolicyHold_twia)
        },
        uwPolicyHold: {
            visible: checkPolicyHold()
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={formData}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

UnderwritingComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string,
    }).isRequired,
    job: PropTypes.shape({
        statusCode: PropTypes.string,
        isEditLocked: PropTypes.bool,
        createdByMe: PropTypes.bool,
        jobNumber: PropTypes.number,
        underwritingIssues: PropTypes.shape({}),
    }),
    continueJob: PropTypes.shape({
        isContinueTransaction: PropTypes.bool,
    }),
    onWithdrawJob: PropTypes.func.isRequired,
    onUpdateJobSummary: PropTypes.func.isRequired,
    onEditJob: PropTypes.func.isRequired,
    jobService: PropTypes.shape({
        referToUnderwriter: PropTypes.string,
    }).isRequired,
    authUserData: PropTypes.shape({
        userType: PropTypes.string,
    }).isRequired,
};
UnderwritingComponent.defaultProps = {
    job: {},
    continueJob: {},
};

export default withAuthenticationContext(UnderwritingComponent);
